import { render, staticRenderFns } from "./frontTag.vue?vue&type=template&id=38b5e3a0&scoped=true&"
import script from "./frontTag.vue?vue&type=script&lang=js&"
export * from "./frontTag.vue?vue&type=script&lang=js&"
import style0 from "./frontTag.vue?vue&type=style&index=0&id=38b5e3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5e3a0",
  null
  
)

export default component.exports